import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Treatment Management
    SETTING_LOAD_TREATMENT_CATEGORY,
    SETTING_CREATE_TREATMENT_CATEGORY,
    SETTING_UPDATE_TREATMENT_CATEGORY,
    SETTING_DELETE_TREATMENT_CATEGORY,

    SETTING_LOAD_TREATMENT,
    SETTING_CREATE_TREATMENT,
    SETTING_UPDATE_TREATMENT,
    SETTING_DELETE_TREATMENT,

    SETTING_UPDATE_TREATMENT_STATUS,
    // END Treatment Management

} from "../../actions";

import {
    // Treatment Management
    settingGetTreatmentCategory,
    settingAddTreatmentCategory,
    settingUpdateTreatmentCategory,
    settingDeleteTreatmentCategory,

    settingGetTreatment,
    settingAddTreatment,
    settingUpdateTreatment,
    settingDeleteTreatment,
    settingUpdateChangeStatusTreatment,

    // END Treatment Management

} from "../../../helpers/setting-api";

import {
    getTreatmentCategory,
    getTreatmentCategorySuccess,
    getTreatment,
    getTreatmentSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Treatment Management
function* settingManagementLoadTreatmentCategory({ payload, token }) {
    try {
        const dataRes = yield settingGetTreatmentCategory(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_treatment_category,
                    value: item.id_treatment_category,
                }
            ));
            yield put(getTreatmentCategorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddTreatmentCategory({ payload, token }) {
    try {
        const dataRes = yield settingAddTreatmentCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getTreatmentCategory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateTreatmentCategory({ payload, token }) {
    try {
        const dataRes = yield settingUpdateTreatmentCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getTreatmentCategory({ spa_id: payload.spa_id }, token));
            yield put(getTreatment({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteTreatmentCategory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteTreatmentCategory(items, token);
        if (dataRes.status === 'success') yield put(getTreatmentCategory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadTreatment({ payload, token }) {
    try {
        const dataRes = yield settingGetTreatment(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_treatment,
                    value: item.id_treatment,
                }
            ));
            yield put(getTreatmentSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddTreatment({ payload, token }) {
    try {
        const dataRes = yield settingAddTreatment(payload, token);
        if (dataRes.status === 'success') {
            yield put(getTreatment({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateTreatment({ payload, token }) {
    try {
        const dataRes = yield settingUpdateTreatment(payload, token);
        if (dataRes.status === 'success') {
            yield put(getTreatment({ spa_id: payload.spa_id }, token));
            // yield put(getTreatmentCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementChangeStatusTreatment({ payload, token }) {
    try {
        const dataRes = yield settingUpdateChangeStatusTreatment(payload, token);
        if (dataRes.status === 'success') {
            yield put(getTreatment({ spa_id: payload.spa_id }, token));

        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteTreatment({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteTreatment(items, token);
        if (dataRes.status === 'success') yield put(getTreatment({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// END Treatment Management

// Treatment Management
export function* watchLoadTreatmentCategory() {
    yield takeEvery(
        SETTING_LOAD_TREATMENT_CATEGORY,
        settingManagementLoadTreatmentCategory
    );
}
export function* watchAddTreatmentCategory() {
    yield takeEvery(
        SETTING_CREATE_TREATMENT_CATEGORY,
        settingManagementAddTreatmentCategory
    );
}
export function* watchUpdateTreatmentCategory() {
    yield takeEvery(
        SETTING_UPDATE_TREATMENT_CATEGORY,
        settingManagementUpdateTreatmentCategory
    );
}
export function* watchDeleteTreatmentCategory() {
    yield takeEvery(
        SETTING_DELETE_TREATMENT_CATEGORY,
        settingManagementDeleteTreatmentCategory
    );
}

export function* watchLoadTreatment() {
    yield takeEvery(
        SETTING_LOAD_TREATMENT,
        settingManagementLoadTreatment
    );
}
export function* watchAddTreatment() {
    yield takeEvery(
        SETTING_CREATE_TREATMENT,
        settingManagementAddTreatment
    );
}
export function* watchUpdateTreatment() {
    yield takeEvery(
        SETTING_UPDATE_TREATMENT,
        settingManagementUpdateTreatment
    );
}
export function* watchChangeStatusTreatment() {
    yield takeEvery(
        SETTING_UPDATE_TREATMENT_STATUS,
        settingManagementChangeStatusTreatment
    );
}
export function* watchDeleteTreatment() {
    yield takeEvery(
        SETTING_DELETE_TREATMENT,
        settingManagementDeleteTreatment
    );
}

// END Treatment Management

export default function* rootSaga() {
    yield all([
        //  Treatment Management 
        fork(watchLoadTreatmentCategory),
        fork(watchAddTreatmentCategory),
        fork(watchUpdateTreatmentCategory),
        fork(watchDeleteTreatmentCategory),

        fork(watchLoadTreatment),
        fork(watchAddTreatment),
        fork(watchUpdateTreatment),
        fork(watchChangeStatusTreatment),
        fork(watchDeleteTreatment),

    ])
}